import React, { Fragment } from 'react';
import * as routes from './path';
import { Route } from 'react-router-dom';

import Dashboard from '../container/Dashboard';
import Students from '../container/student';
import Users from '../container/users';
import Parent from '../container/parent';
import Staff from '../container/staff';
import Group from '../container/group';
import AddStudentsBulk from '../container/addStudentsBulk';
import GroupDetail from '../container/groupDetail';
import AttendanceSummary from '../container/AttendanceSummary';
import ParentManageForm from '../component/parentManage';
import StaffManageForm from '../component/staffManage';
import UserManageForm from '../component/studentManage';
import Photos from '../container/photos'


export default function ParentRoutes() {
    return (
        <Fragment>
            <Route component={Photos} path={routes.Photos} exact />
        </Fragment>
    );
}

